import { ApolloLink, Observable } from "apollo-link";

/**
 * Taken from official docs:
 * https://www.apollographql.com/docs/react/migrating/boost-migration/#after-1
 */
const requestLink = request =>
	new ApolloLink(
		(operation, forward) =>
			new Observable(observer => {
				let subscription;
				Promise.resolve(operation)
					.then(oper => request(oper))
					.then(oper => {
						subscription = forward(oper || operation).subscribe({
							next: observer.next.bind(observer),
							error: observer.error.bind(observer),
							complete: observer.complete.bind(observer),
						});
					})
					.catch(observer.error.bind(observer));

				return () => {
					if (subscription) subscription.unsubscribe();
				};
			}),
	);

export default requestLink;
